var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEpikoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5694 6.20564L17.7877 0.719238L12.9419 6.20564L17.7877 8.99137L22.5694 6.20564Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7878 11.7599L29.769 4.85208L27.4277 14.4626L34.6039 10.3513L30.5983 26.519L23.3814 30.5934L27.4277 14.4626L17.7878 19.9941L8.15542 14.4729L12.1494 30.5934L5.02292 26.519L0.926758 10.3525L8.15542 14.4729L5.74835 4.79688L17.7878 11.7599Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpikoIcon);
export default __webpack_public_path__ + "static/media/epiko-icon.b05890c5c6257425693b6faaca16a133.svg";
export { ForwardRef as ReactComponent };